import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenceTransferDetails } from "../../../api/ILicenceTransfer";
import { ILicenceProfile } from "../../../api/LicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  licenceTransferDetails: ILicenceTransferDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  licenceTransferDetails,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions`}
        >
          Authorisation Versions
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions/${licenceTransferDetails.licenceid}`}
        >
          {licenceTransferDetails.licence_regno}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {licenceTransferDetails.casenumber}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
